import { render, staticRenderFns } from "./LeadsBiodata.vue?vue&type=template&id=77d23596"
import script from "./LeadsBiodata.vue?vue&type=script&lang=js"
export * from "./LeadsBiodata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports